import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Preferences from '../generics/Preferences';
import url from '../constants/urlsPaths';
import Axios from 'axios';
import './UserManager.css';

export default function UserManager() {
    const [user, setUser] = useState({ email: '', code: '', company: '', language: '', type: '' });
    const [companies, setCompanies] = useState([])

    useEffect(() => {
        Axios.post(url.getCompanies, { code: sessionStorage.getItem("code") },
        {
            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
        })
        .then(res => {
            setCompanies(res.data);
        })
        .catch(err => {
            console.log(err)
        })

    }, [])
    

    const handleChange = (e) => {
        const newUser = { ...user }
        newUser[e.target.name] = e.target.value
        setUser(newUser)
        // check dates function if from is lower to to and before date now
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        Axios.post(url.addUser, {code: sessionStorage.getItem("code") },
        {
            headers: { "x-access-token": JSON.parse(sessionStorage.getItem("token") || "null") }
        })
        .then(res => {
            alert('user added !');
            setUser({})
            console.log(res)
        })
        .catch(err => {
            console.log(err)
        })
    }

    return (
        <div id="UserManager">
            <Preferences />
            <div id="UserManager-header">
                <Link to='/manager' className="UserManager-back-btn">Back to manager</Link>
                <h2>Add user</h2>
            </div>
            <div id="UserManager-content">
                <form className='UserManager-form' onSubmit={handleSubmit}>
                    <label><p>Email:</p><input type='email' name='email' value={user.email} onChange={handleChange} required /></label>
                    <label><p>Language:</p>
                        <select name='language' value={user.language} onChange={handleChange} required>
                            <option value=''>None</option>
                            <option value='fr' onChange={handleChange}>fr</option>
                            <option value='en' onChange={handleChange}>en</option>
                            <option value='de' onChange={handleChange}>de</option>
                        </select>
                    </label>

                    <label><p>Company:</p>
                        <select name='company' value={user.company} onChange={handleChange} required>
                            {
                                companies?.map(company => {
                                    return (
                                        <option key={company.id} value={company.id} onChange={handleChange}>{company.name}</option>
                                    )
                                })
                            }
                        </select>
                    </label>

                    <label><p>Type:</p>
                        <select name='type' value={user.type} onChange={handleChange} required>
                            <option value=''>None</option>
                            <option value='user' onChange={handleChange}>User</option>
                            <option value='admin' onChange={handleChange}>Admin</option>
                        </select>
                    </label>
                    <div className='UserManager-submit'><button type='submit'>Add user</button></div>
                </form>
            </div>
        </div>
    )
}
